import React from 'react';
import { useLocation } from 'react-router-dom';
import styles from './HeaderBurger.module.scss';
import LogoImg from '../../../../../assests/images/aqrotexnika.png';
import {
  SVGaddCard,
  SVGuser,
  SVGbackArrow,
  SVGsearch,
  SVGepmtyWp,
  SVGfaceBook,
  SVGinstagram,
  SVGPhone,
} from '../../../../../assests/icons/';
import { getLanguageItems } from '../../../../../mock/mockHeaderItems';

function HeaderBurger(props) {
  const { handleChangeBurgerMenuShow, burgerMenuShow } = props;
  const location = useLocation();
  const isRussian = location.pathname.includes('/ru');

  // Get the appropriate header items based on language
  const headerItems = getLanguageItems(location.pathname);

  const closeMenu = () => {
    handleChangeBurgerMenuShow();
  };

  return (
      <div onClick={closeMenu} className={styles.overlay}>
        <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={`${styles.burger__parent} ${
                burgerMenuShow ? styles.active : ''
            }`}
        >
          <div className={styles.header__burger}>
            <div
                className={styles.header__burger__back}
                onClick={handleChangeBurgerMenuShow}
            >
              <SVGbackArrow fill="#000" />
            </div>
            <div className={styles.header__logo}>
              <a href={isRussian ? "/ru/ana-sehife" : "/ana-sehife"}>
                <div className={styles.logoImgContainer}>
                  <img className={styles.logoImg} src={LogoImg} alt="" />
                </div>
              </a>
            </div>
          </div>
          <div className={styles.burger__menu}>
            {headerItems.map((item) => (
                <div key={item.id} className={styles.burger__menu__link}>
                  <a href={item.url}>{item.title}</a>
                </div>
            ))}

            <div className={styles.contactInfo}>
              <p>
              <span>
                <SVGPhone />
              </span>{' '}
                +994 (51) 230 00 30
              </p>
              <div className={styles.socials}>
                <a href="https://www.facebook.com/aqrotexnika.az" target="_blank" rel="noopener noreferrer">
                  <SVGfaceBook />
                </a>
                <a href="https://instagram.com/aqrotexnika.az" target="_blank" rel="noopener noreferrer">
                  <SVGinstagram />
                </a>
                {/* Language switcher */}
                <a
                    href={isRussian ? location.pathname.replace('/ru', '') : `/ru${location.pathname}`}
                    className={styles.langSwitch}
                >
                  {isRussian ? "AZ" : "RU"}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default HeaderBurger;